import { render, staticRenderFns } from "./msgUpload.vue?vue&type=template&id=65168587"
import script from "./msgUpload.vue?vue&type=script&lang=js"
export * from "./msgUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65168587')) {
      api.createRecord('65168587', component.options)
    } else {
      api.reload('65168587', component.options)
    }
    module.hot.accept("./msgUpload.vue?vue&type=template&id=65168587", function () {
      api.rerender('65168587', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/lang/msgUpload.vue"
export default component.exports